<template>
  <div class="header-nav">
    <div class="header-nav-left">
      <!-- <div
        v-show="$route.path == '/video-call' ||  $route.path == '/audio-call'? true : false"
        class="header-nav-homepage"
        @click="gotoHomePage"
      >
        <i class="el-icon-arrow-down el-icon-arrow-left"></i>
        返回
      </div> -->
    </div>

    <!-- <img class="header-nav-title-img" src="../../assets/zs.png" alt="" /> -->
    <!-- <div class="header-nav-title">
      <div class="header-nav-title-text">远程视频核验</div>
    </div> -->
    <div class="header-nav-help">
      <!-- <el-dropdown
        @command="handleCommand"
        v-show="$route.path == '/video-call' ? true : false"
      >
        <span class="el-dropdown-link">
          更多
          <i class="el-icon-arrow-down el-icon-more"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="command-detect">设备检测</el-dropdown-item> -->
          <!-- <el-dropdown-item command="command-switch"
            >切换摄像头</el-dropdown-item
          > -->
        <!-- </el-dropdown-menu>
      </el-dropdown> -->
    </div>

    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <!-- <camera-Select
        deviceType="camera"
        @change="handleValueChange($event, 'cameraId')"
      >
      </camera-Select> -->
      <button @click="handleValueChange"></button>
      <!-- <el-select @change="switchCamer" v-model="deviceId" placeholder="请选择">
        <el-option
          v-for="item in cameraSwitch"
          :key="item.deviceId"
          :label="item.label"
          :value="item.deviceId"
        >
        </el-option>
      </el-select> -->
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { setUserLoginInfo } from "../../utils";
import cameraSelect from "../../components/select";
import TRTC from "trtc-js-sdk";
import { createTrtcCalling } from "../../trtc-calling";
export default {
  name: "HeaderNav",
  data() {
    return {
      cameraSwitch: [],
      dialogVisible: false,
      deviceId: "",
      localStream: "",
      cameraId: "",
    };
  },
  components: {
    cameraSelect,
  },
  methods: {
    handleValueChange(value, key) {
      // this[key] = value;
      // let userID = this.$store.state.loginUserInfo.userId;
      // this.localStream = TRTC.createStream({
      //   userID,
      //   audio: true,
      //   video: true,
      // });
      //  this.localStream.switchDevice('video', value);
      // this.localStream.switchDevice("video", value).then(() => {
      // this.$message.success("切换成功");
      // });
    },
    handleCommand: function (command) {
      if (command === "command-detect") {
        window.open(
          "https://web.sdk.qcloud.com/trtc/webrtc/demo/detect/index.html",
          "__blank"
        );
        return;
      }

      if (command === "command-switch") {
        TRTC.getCameras()
          .then((devices) => {
            this.cameraSwitch = devices;
            if (this.cameraSwitch.length <= 0) {
              this.$message.error("未检测到摄像头设备");
              return;
            }
            this.dialogVisible = true;
          })
          .catch((err) => {
            this.$message.error("未检测到摄像头设备");
          });
        // this.$trtcCalling.logout();
        // this.$store.commit("userLogoutSuccess");
        // setUserLoginInfo({
        //   token: "",
        //   phoneNum: ""
        // });
      }
    },
    gotoHomePage: function () {
      if (this.$router.currentRoute.fullPath !== "/") {
        this.$router.push("/");
      }
    },
  },
  created() {},
};
</script>

<style scoped>
.header-nav {
  height: 70px;
  display: flex;
  /* padding: 0 20%; */
  justify-content: space-around;
  color: #ffffff;
}
.header-nav-left {
  display: flex;
  flex-direction: row;
}
.header-nav-title {
  position: relative;
  display: flex;
}
.header-nav-title-text {
  text-shadow: #013667 0px 2px 3px;
  font-size: 46px;
}
.header-nav-title-img {
  position: absolute;
  width: 400px;
  height: 12px;
  top: 54px;
}
.header-nav-homepage {
  /* margin-left: 50px; */
  font-size: 28px;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.header-nav-help {
  font-size: 20px;
  display: flex;
  align-items: center;
}
.el-dropdown-link {
  color: #ffffff;
  font-size: 28px;
  cursor: pointer;
}
@media screen and (max-width: 767px) {
  .header-nav {
    padding: 0;
  }
  .header-nav-left {
    justify-content: space-around;
    /* width: 75%; */
  }
  .header-nav-title,
  .el-dropdown-link {
    font-size: 18px;
  }
  .header-nav-homepage {
    font-size: 18px;
    /* margin-left: 10px; */
  }
}
</style>
